import { render, staticRenderFns } from "./ListaPrecioListadoProductosComponent.vue?vue&type=template&id=65f2c791&"
import script from "./ListaPrecioListadoProductosComponent.vue?vue&type=script&lang=js&"
export * from "./ListaPrecioListadoProductosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports